export default __webpack_public_path__ + "static/media/icon_checkmark-blue.dd73b33b.svg";